import React, { Component } from 'react';
import s from './Header.css';
import com from './common.css';

import PageLinks from "./PageLinks.js";

export default class Header extends Component {

  render(){
    return pug`
      header(className=s.header)
        div(className=com.content)
          h1(className=s.title) 忍者プログラマー、
            wbr
            |主君求むでござる。
          p(className=s.intro) あらすじ
            br
            |JavaScriptを最も得意とする忍者プログラマーマサは、東京でフリーランスとして
            del
              small 暗躍
            ins 活動
            |していた！ 2018年4月より新設された三重大学大学院 忍者・忍術学コースに入学し、Master of Ninja
            small (非公式)
            |の称号を得るために三重県津市に移り住んだ！三重県で仕えるべき
            del
              small 主君
            ins 会社
            |を求め、Webの海を水遁の術で漂っているのであった・・・。
          
          
          PageLinks

          
    `;
  }
}



// WEBPACK FOOTER //
// ./src/Header.js